import { Component, inject, OnInit, viewChild, ViewContainerRef } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { InternationalizationService } from '@core/internationalization/internationalization.service';
import { PushService } from '@core/push/push.service';
import { CustomPortalService } from '@core/services/custom-portal.service';
import { AuthService } from '@features/auth/auth.service';
import { BILLING_MODAL } from '@features/settings/billing/components/billing-dashboard/billing-dashboard.config';
import { BillingService } from '@features/settings/billing/services/billing.service';
import { CancelSubSuccessModalComponent } from './features/settings/billing/components/cancel-sub-success-modal/cancel-sub-success-modal.component';
import { UpgradePricingModalComponent } from './features/settings/billing/components/upgrade-pricing-modal/upgrade-pricing-modal.component';
import { UpgradedGrowthPlanModalComponent } from './features/settings/billing/components/upgraded-growth-plan-modal/upgraded-growth-plan-modal.component';

@Component({
    selector: 'app-root',
    template: `
        <router-outlet />

        <!-- This must be removed when new billing plans are implemented -->
        @switch (modalOpen()) {
            @case (BILLING_MODAL.cancel) {
                <set-cancel-sub-success-modal
                    class="absolute inset-0 z-20"
                    (onClose)="modalOpen.set(null)" />
            }
            @case (BILLING_MODAL.upgrade) {
                <app-upgrade-pricing-modal (onClose)="modalOpen.set(null)" />
            }
            @case (BILLING_MODAL.updateToGrowthSuccess) {
                <app-upgraded-growth-plan-modal (onClose)="modalOpen.set(null)" />
            }
        }
        <!--  -->

        <ng-template #project />
    `,
    imports: [
        RouterOutlet,
        CancelSubSuccessModalComponent,
        UpgradePricingModalComponent,
        UpgradedGrowthPlanModalComponent,
    ],
})
export class AppComponent implements OnInit {
    private readonly authService = inject(AuthService);
    private readonly billingS = inject(BillingService);
    private readonly customPortalS = inject(CustomPortalService);
    private readonly internationalizationS = inject(InternationalizationService);
    private readonly pushS = inject(PushService);

    // This must be removed when new billing plans are implemented
    readonly modalOpen = this.billingS.modalOpen;
    readonly BILLING_MODAL = BILLING_MODAL;

    protected readonly portalContainer = viewChild.required('project', {
        read: ViewContainerRef,
    });

    constructor() {
        // For debugging router navigation issues
        // inject(Router).events.subscribe(ev => {
        //     console.log(ev);
        // });
    }

    ngOnInit() {
        this.internationalizationS.init();
        this.customPortalS.init(this.portalContainer());
        this.pushS.init();

        this.authService.checkIsLoggedIn();
    }
}
